import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { DropDownMenu, MenuItem } from "material-ui";
import { connect } from "react-redux";
import { setValue } from "../../store/actions/TripsActions";

import styles from "./styles.scss";

@connect(state => ({
  filter: state.Trips.get("filter"),
  selectedUser: state.Trips.get("selectedUser")
}))
export default class TripListFilter extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    users: PropTypes.shape(),
    numFiltered: PropTypes.number.isRequired,
    numTrips: PropTypes.number.isRequired,
    filter: PropTypes.string.isRequired,
    selectedUser: PropTypes.string.isRequired
  };

  static defaultProps = {
    users: {}
  };

  updateFilter = (e, index, value) =>
    this.props.dispatch(setValue("filter", value));

  selectUser = (e, index, value) =>
    this.props.dispatch(setValue("selectedUser", value));

  render() {
    const {
      users,
      numFiltered,
      numTrips,
      filter: filterNeed,
      selectedUser
    } = this.props;

    return (
      <div className={styles.listFilter}>
        <div className={styles.tripListFilters}>
          <div className={styles.filter}>
            <span>Assigned to:</span>
            <DropDownMenu value={selectedUser} onChange={this.selectUser}>
              <MenuItem value="all" primaryText="All" />
              {_.values(users).map(user => {
                const { id, name } = user;

                return <MenuItem key={id} value={id} primaryText={name} />;
              })}
            </DropDownMenu>
          </div>
          <div className={styles.filter}>
            <span>Filter by:</span>
            <DropDownMenu value={filterNeed} onChange={this.updateFilter}>
              <MenuItem value="all" primaryText="------" />
              <MenuItem value="prospect" primaryText="prospect" />
              <MenuItem value="insideCircle" primaryText="Inside Circle" />
              <MenuItem value="highPriority" primaryText="BMOC" />
              <MenuItem value="book" primaryText="needs booking" />
              <MenuItem value="filing" primaryText="needs filing" />
              <MenuItem value="invoice" primaryText="needs invoicing" />
              <MenuItem
                value="actionableInvoice"
                primaryText="has actionable invoice"
              />
              <MenuItem value="vip" primaryText="needs VIP" />
              <MenuItem value="welcomeHome" primaryText="needs Welcome Home" />
              <MenuItem value="training" primaryText="needs training" />
              <MenuItem value="vetting" primaryText="needs vetting" />
              <MenuItem value="cancellation" primaryText="has cancellation" />
            </DropDownMenu>
          </div>
        </div>
        <div className={styles.infoLine}>
          {numFiltered} (of {numTrips}) trips displayed
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /src/components/Trips/TripListFilters.js